import React, { useEffect, useState } from "react";
import styles from "./SideBar.module.scss";
import blue_radio from "../assets/Images/blue_radio.svg";
import gray_radio from "../assets/Images/gray_radio.svg";
import stylus from "../assets/Images/stylus.svg";
import aadharicongrey from "../assets/Images/aadharicongrey.svg";
import identityblackicon from "../assets/Images/identityblackicon.svg";
import bankicongrey from "../assets/Images/bankicongrey.svg";
import bankblackicon from "../assets/Images/bankblackicon.svg";
import nomineeicongrey from "../assets/Images/nomineeicongrey.svg";
import uploadimagegray from "../assets/Images/uploadnewgrayicon.svg";
import uploadnewblackicon from "../assets/Images/uploadnewblackicon.svg";
import sigicon from "../assets/Images/newesigngrayicon.svg";
import esignnewblackicon from "../assets/Images/esignnewblackicon.svg";
import FirtsockLogo from "../assets/Images/firstockLogoBadge.svg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";

const MappingValues: any = {
  pan: "PAN Validation",
  kra_or_aadhaar: "Aadhar Validation",
  customer_details: "About Yourself",
  ipv: "Identity Verification",
  segment: "Trading Preference",
  t_and_c: "Terms & Condition",
  nominee: "Nominee",
  esign: "Esign",
  bank: "Bank Account",
  document_upload: "Document Upload",
};

const SideBar = () => {
  const navigate = useNavigate();
  const completedstages = useSelector(
    (state: any) => state.PATHNAME.completedstages,
  );
  const currentstage = useSelector((state: any) => state.PATHNAME.currentstage);

  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  const [mode, setMode] = useState(getSystemTheme());

  useEffect(() => {
    setMode(getSystemTheme());
  }, [getSystemTheme]);

  // console.log("completedstages", completedstages);

  const panstage =
    currentstage === "pan"
      ? "In Progress"
      : completedstages?.includes("pan")
        ? "Completed"
        : "Pending";
  const bankstage =
    currentstage === "bank"
      ? "In Progress"
      : completedstages?.includes("bank")
        ? "Completed"
        : "Pending";
  const uploaddocuments =
    currentstage === "document_upload"
      ? "In Progress"
      : completedstages?.includes("document_upload")
        ? "Completed"
        : "Pending";
  const esignstage =
    currentstage === "esign"
      ? "In Progress"
      : completedstages?.includes("esign")
        ? "Completed"
        : "Pending";

  const handleLogout = () => {
    confirmAlert({
      title: "",
      message: "Are you sure you want to logout?",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            sessionStorage.clear();
            window.location.href = "/";
          },
        },
      ],
    });
  };

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.companyLogo}>
        <img
          src={FirtsockLogo}
          style={{
            zIndex: 100,
            cursor: "pointer",
            // filter:
            //   mode === "dark" ? "grayscale(0.9) invert(0.9) brightness(1)" : "",
          }}
          onClick={() => {}}
          className={styles.logoBase}
        />
        <span className={styles.logoText}>Firstock</span>
      </div>
      <div className={styles.progressSection}>
        <div className={styles.top}>
          <div className={styles.progressSectionTop}>
            <img src={blue_radio} />

            <div className={styles.progressBar}>
              <div
                className={styles.progressFill}
                style={{
                  height:
                    completedstages && completedstages?.length >= 4
                      ? "100%"
                      : completedstages?.length
                        ? `${completedstages?.length * 33}%`
                        : currentstage === "pan"
                          ? "10%"
                          : `${completedstages?.length * 50}%`,
                }}
              ></div>
            </div>
          </div>
          <div>
            <div className={styles.details}>
              <div
                className={styles.title}
                style={{
                  color:
                    panstage === "Completed" || panstage === "In Progress"
                      ? "var(--ds-text-primary)"
                      : "",
                }}
              >
                <img
                  src={
                    panstage === "Completed" || panstage === "In Progress"
                      ? identityblackicon
                      : aadharicongrey
                  }
                  className={styles.icon}
                  // style={{
                  //   filter:
                  //     mode === "dark"
                  //       ? "grayscale(0.9) invert(0.9) brightness(1)"
                  //       : "",
                  // }}
                />
                Identity Verification
              </div>
              <div className={styles.stagesWrapper}>
                <div
                  className={styles.stages}
                  style={{
                    color: completedstages?.includes("pan") ? "#3263E5" : "",
                  }}
                >
                  <div
                    className={styles.dot}
                    style={{
                      background: completedstages?.includes("pan")
                        ? "#3263E5"
                        : "",
                    }}
                  ></div>{" "}
                  Pan / KRA Verification
                </div>
                <div className={styles.seperator}> - </div>
                <div
                  className={styles.stages}
                  style={{
                    color: completedstages?.includes("customer_details")
                      ? "#3263E5"
                      : "",
                  }}
                >
                  <div
                    className={styles.dot}
                    style={{
                      background: completedstages?.includes("customer_details")
                        ? "#3263E5"
                        : "",
                    }}
                  ></div>{" "}
                  Personal details
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.top}>
          <div className={styles.progressSectionTop}>
            <img src={completedstages?.length >= 4 ? blue_radio : gray_radio} />
            <div className={styles.progressBar}>
              <div
                className={styles.progressFill}
                style={{
                  height:
                    completedstages && completedstages?.length >= 6
                      ? "100%"
                      : `${completedstages?.slice(3, 5)?.length * 50}%`,
                }}
              ></div>
            </div>
          </div>
          <div>
            <div className={styles.details}>
              <div
                className={styles.title}
                style={{
                  color:
                    bankstage === "Completed" || bankstage === "In Progress"
                      ? "var(--ds-text-primary)"
                      : "",
                }}
              >
                <img
                  src={
                    bankstage === "Completed" || bankstage === "In Progress"
                      ? bankblackicon
                      : bankicongrey
                  }
                  className={styles.icon}
                  // style={{
                  //   filter:
                  //     mode === "dark"
                  //       ? "grayscale(0.9) invert(0.9) brightness(1)"
                  //       : "",
                  // }}
                />
                Bank Details
              </div>
              <div className={styles.stagesWrapper}>
                <div
                  className={styles.stages}
                  style={{
                    color: completedstages?.includes("bank") ? "#3263E5" : "",
                  }}
                >
                  <div
                    className={styles.dot}
                    style={{
                      background: completedstages?.includes("bank")
                        ? "#3263E5"
                        : "",
                    }}
                  ></div>{" "}
                  Bank Details
                </div>
                <div className={styles.seperator}> - </div>
                <div
                  className={styles.stages}
                  style={{
                    color: completedstages?.includes("segment")
                      ? "#3263E5"
                      : "",
                  }}
                >
                  <div
                    className={styles.dot}
                    style={{
                      background: completedstages?.includes("segment")
                        ? "#3263E5"
                        : "",
                    }}
                  ></div>{" "}
                  Trading Preference
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.top}>
          <div className={styles.progressSectionTop}>
            <img src={completedstages?.length >= 5 ? blue_radio : gray_radio} />
            <div className={styles.progressBar}>
              <div
                className={styles.progressFill}
                style={{
                  height:
                    completedstages && completedstages?.length >= 8
                      ? "100%"
                      : `${completedstages?.slice(5, 8)?.length * 34}%`,
                }}
              ></div>
            </div>
          </div>
          <div>
            <div className={styles.details}>
              <div
                className={styles.title}
                style={{
                  color:
                    uploaddocuments === "Completed" ||
                    uploaddocuments === "In Progress"
                      ? "var(--ds-text-primary)"
                      : "",
                }}
              >
                <img
                  src={
                    uploaddocuments === "Completed" ||
                    uploaddocuments === "In Progress"
                      ? uploadnewblackicon
                      : uploadimagegray
                  }
                  className={styles.icon}
                  // style={{
                  //   filter:
                  //     mode === "dark"
                  //       ? "grayscale(0.9) invert(0.9) brightness(1)"
                  //       : "",
                  // }}
                />
                Upload Documents
              </div>
              <div className={styles.stagesWrapper}>
                <div
                  className={styles.stages}
                  style={{
                    color: completedstages?.includes("document_upload")
                      ? "#3263E5"
                      : "",
                  }}
                >
                  <div
                    className={styles.dot}
                    style={{
                      background: completedstages?.includes("document_upload")
                        ? "#3263E5"
                        : "",
                    }}
                  ></div>{" "}
                  Upload Documents
                </div>
                <div className={styles.seperator}> - </div>
                <div
                  className={styles.stages}
                  style={{
                    color: completedstages?.includes("ipv") ? "#3263E5" : "",
                  }}
                >
                  <div
                    className={styles.dot}
                    style={{
                      background: completedstages?.includes("ipv")
                        ? "#3263E5"
                        : "",
                    }}
                  ></div>{" "}
                  Photo for verification.
                </div>
                <div className={styles.seperator}> - </div>
                <div
                  className={styles.stages}
                  style={{
                    color: completedstages?.includes("nominee")
                      ? "#3263E5"
                      : "",
                  }}
                >
                  <div
                    className={styles.dot}
                    style={{
                      background: completedstages?.includes("nominee")
                        ? "#3263E5"
                        : "",
                    }}
                  ></div>{" "}
                  Nomination Details
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.top}>
          <div className={styles.progressSectionTop}>
            <img src={completedstages?.length >= 8 ? blue_radio : gray_radio} />
          </div>
          <div>
            <div className={styles.details}>
              <div
                className={styles.title}
                style={{
                  color:
                    esignstage === "Completed" || esignstage === "In Progress"
                      ? "var(--ds-text-primary)"
                      : "",
                }}
              >
                <img
                  src={
                    esignstage === "Completed" || esignstage === "In Progress"
                      ? esignnewblackicon
                      : sigicon
                  }
                  className={styles.icon}
                  // style={{
                  //   filter:
                  //     mode === "dark"
                  //       ? "grayscale(0.9) invert(0.9) brightness(1)"
                  //       : "",
                  // }}
                />
                Submit
              </div>
              <div className={styles.stagesWrapper}>
                <div
                  className={styles.stages}
                  style={{
                    color: currentstage === "esign" ? "#3263E5" : "",
                  }}
                >
                  <div
                    className={styles.dot}
                    style={{
                      background: currentstage === "esign" ? "#3263E5" : "",
                    }}
                  ></div>{" "}
                  E-sign Preview
                </div>
                <div className={styles.seperator}> - </div>
                <div className={styles.stages}>
                  <div className={styles.dot}></div> Submit
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.sidebarFooter}>
        <div
          className={styles.footerItem}
          onClick={() => {
            handleLogout();
          }}
        >
          Logout{" "}
        </div>
        {/* <div className={styles.footerItem}>FAQ </div> */}
        <div
          className={styles.footerItem}
          onClick={() => {
            window.open("https://firstock.in/support/", "_blank");
          }}
        >
          Support{" "}
        </div>
      </div>
    </div>
  );
};

export default SideBar;
